/* NIDOREA theme JS — vanilla, no dependencies */
(function () {
    "use strict";

    var ND = window.ND || {};

    function fmt(cents) {
        var v = (cents / 100).toFixed(2);
        var f = ND.moneyFormat || "€{{amount}}";
        return f.replace(/\{\{\s*amount\s*\}\}/g, v);
    }

    function toast(msg) {
        var t = document.querySelector(".nd-toast");
        if (!t) return;
        t.textContent = msg;
        t.classList.add("nd-show");
        clearTimeout(t._h);
        t._h = setTimeout(function () { t.classList.remove("nd-show"); }, 2600);
    }

    /* ---------- header scroll ---------- */
    var header = document.querySelector(".nd-header");
    function onScroll() {
        if (header) header.classList.toggle("nd-scrolled", window.scrollY > 24);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    /* ---------- announcement rotation ---------- */
    var ann = document.querySelector("[data-nd-announce]");
    if (ann) {
        var msgs = (ann.getAttribute("data-nd-announce") || "").split("|").filter(Boolean);
        if (msgs.length > 1) {
            var ai = 0;
            setInterval(function () {
                ai = (ai + 1) % msgs.length;
                ann.style.opacity = "0";
                setTimeout(function () {
                    ann.textContent = msgs[ai];
                    ann.style.opacity = "1";
                }, 400);
            }, 5000);
        }
    }

    /* ---------- reveal on scroll ---------- */
    var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
            if (e.isIntersecting) {
                e.target.classList.add("nd-in");
                io.unobserve(e.target);
            }
        });
    }, { rootMargin: "-60px" });
    document.querySelectorAll(".nd-reveal").forEach(function (el) { io.observe(el); });

    /* ---------- search / mobile menu ---------- */
    function bindToggle(triggerSel, targetSel) {
        var trigger = document.querySelector(triggerSel);
        var target = document.querySelector(targetSel);
        if (!trigger || !target) return;
        trigger.addEventListener("click", function () {
            target.classList.toggle("nd-open");
            var inp = target.querySelector("input");
            if (inp && target.classList.contains("nd-open")) inp.focus();
        });
        target.querySelectorAll("[data-nd-close]").forEach(function (b) {
            b.addEventListener("click", function () { target.classList.remove("nd-open"); });
        });
    }
    bindToggle("[data-nd-search-trigger]", ".nd-search");
    bindToggle("[data-nd-menu-trigger]", ".nd-mobile");

    /* ---------- cart drawer ---------- */
    var drawer = document.querySelector(".nd-drawer");
    var overlay = document.querySelector(".nd-overlay");

    function openDrawer() {
        if (drawer) drawer.classList.add("nd-open");
        if (overlay) overlay.classList.add("nd-open");
        document.body.style.overflow = "hidden";
    }
    function closeDrawer() {
        if (drawer) drawer.classList.remove("nd-open");
        if (overlay) overlay.classList.remove("nd-open");
        document.body.style.overflow = "";
    }
    document.querySelectorAll("[data-nd-cart-open]").forEach(function (b) {
        b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
    });
    document.querySelectorAll("[data-nd-cart-close]").forEach(function (b) {
        b.addEventListener("click", closeDrawer);
    });
    if (overlay) overlay.addEventListener("click", closeDrawer);

    function renderCart(cart) {
        var itemsEl = document.querySelector("[data-nd-cart-items]");
        var footEl = document.querySelector("[data-nd-cart-foot]");
        var countEls = document.querySelectorAll("[data-nd-cart-count]");
        var titleEl = document.querySelector("[data-nd-cart-title]");
        countEls.forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? "flex" : "none";
        });
        if (titleEl) titleEl.textContent = "Your Bag (" + cart.item_count + ")";
        if (!itemsEl || !footEl) return;

        var threshold = (ND.freeShipping || 150) * 100;
        var shipEl = document.querySelector("[data-nd-ship-msg]");
        var barEl = document.querySelector("[data-nd-ship-bar]");
        if (shipEl) {
            var remaining = Math.max(0, threshold - cart.total_price);
            shipEl.textContent = remaining > 0
                ? fmt(remaining) + " away from complimentary shipping"
                : "Your order ships free";
        }
        if (barEl) barEl.style.width = Math.min(100, (cart.total_price / threshold) * 100) + "%";

        if (cart.item_count === 0) {
            itemsEl.innerHTML =
                '<div class="nd-drawer__empty"><h3>Your bag is empty.</h3>' +
                '<p style="margin-top:8px;font-size:14px;color:var(--fog)">Beautiful things take a moment to find.</p>' +
                '<a href="/collections/all" class="nd-btn nd-btn--ghost" style="margin-top:32px">Explore the collection</a></div>';
            footEl.style.display = "none";
            return;
        }
        footEl.style.display = "";
        itemsEl.innerHTML = cart.items.map(function (i) {
            var variant = [i.variant_title].filter(Boolean).join(" · ");
            return (
                '<div class="nd-drawer__item">' +
                '<img src="' + (i.image || "") + '" alt="">' +
                '<div style="flex:1;display:flex;flex-direction:column">' +
                '<div style="display:flex;justify-content:space-between;gap:8px">' +
                '<h4>' + i.product_title + "</h4>" +
                '<button class="nd-drawer__remove" data-nd-remove="' + i.key + '" aria-label="Remove">&times;</button>' +
                "</div>" +
                (variant && variant !== "Default Title" ? '<p class="nd-variant">' + variant + "</p>" : "") +
                '<div style="margin-top:auto;display:flex;justify-content:space-between;align-items:center;padding-top:8px">' +
                '<span class="nd-drawer__qty">' +
                '<button data-nd-qty="' + i.key + '" data-delta="-1">−</button>' +
                "<span>" + i.quantity + "</span>" +
                '<button data-nd-qty="' + i.key + '" data-delta="1">+</button>' +
                "</span>" +
                '<span class="nd-mono" style="font-size:14px">' + fmt(i.final_line_price) + "</span>" +
                "</div></div></div>"
            );
        }).join("");

        var subEl = document.querySelector("[data-nd-subtotal]");
        if (subEl) subEl.textContent = fmt(cart.total_price);

        itemsEl.querySelectorAll("[data-nd-remove]").forEach(function (b) {
            b.addEventListener("click", function () { changeQty(b.getAttribute("data-nd-remove"), 0); });
        });
        itemsEl.querySelectorAll("[data-nd-qty]").forEach(function (b) {
            b.addEventListener("click", function () {
                var key = b.getAttribute("data-nd-qty");
                var item = cart.items.find(function (i) { return i.key === key; });
                if (item) changeQty(key, Math.max(0, item.quantity + parseInt(b.getAttribute("data-delta"), 10)));
            });
        });
    }

    function refreshCart() {
        fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
    }

    function changeQty(key, qty) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity: qty }),
        }).then(function (r) { return r.json(); }).then(renderCart);
    }

    /* ---------- add to cart (ajax) ---------- */
    document.querySelectorAll("form[data-nd-atc]").forEach(function (form) {
        form.addEventListener("submit", function (e) {
            e.preventDefault();
            var id = form.querySelector("[name=id]");
            var qty = form.querySelector("[name=quantity]");
            if (!id || !id.value) { toast("Please select an option first."); return; }
            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    items: [{ id: parseInt(id.value, 10), quantity: qty ? parseInt(qty.value, 10) : 1 }],
                }),
            })
                .then(function (r) { return r.json(); })
                .then(function () {
                    toast("Added to your bag.");
                    refreshCart();
                    openDrawer();
                })
                .catch(function () { toast("Could not add to bag — please try again."); });
        });
    });
    refreshCart();

    /* ---------- shop the look ---------- */
    document.querySelectorAll("[data-nd-look]").forEach(function (section) {
        var tabs = section.querySelectorAll("[data-nd-room]");
        var rooms = section.querySelectorAll("[data-nd-room-panel]");
        tabs.forEach(function (tab) {
            tab.addEventListener("click", function () {
                var id = tab.getAttribute("data-nd-room");
                tabs.forEach(function (t) { t.classList.toggle("nd-active", t === tab); });
                rooms.forEach(function (r) {
                    r.style.display = r.getAttribute("data-nd-room-panel") === id ? "" : "none";
                });
            });
        });
        section.querySelectorAll(".nd-hotspot > span").forEach(function (dot) {
            dot.parentElement.addEventListener("click", function () {
                section.querySelectorAll(".nd-hotspot").forEach(function (h) {
                    if (h !== dot.parentElement) h.classList.remove("nd-active");
                });
                dot.parentElement.classList.toggle("nd-active");
            });
        });
    });

    /* ---------- product page ---------- */
    document.querySelectorAll("[data-nd-pdp]").forEach(function (pdp) {
        var main = pdp.querySelector("[data-nd-main-img]");
        pdp.querySelectorAll("[data-nd-thumb]").forEach(function (btn) {
            btn.addEventListener("click", function () {
                if (main) main.src = btn.getAttribute("data-nd-thumb");
                pdp.querySelectorAll("[data-nd-thumb]").forEach(function (b) { b.classList.remove("nd-active"); });
                btn.classList.add("nd-active");
            });
        });

        var variantsEl = pdp.querySelector("[data-nd-variants]");
        if (!variantsEl) return;
        var variants = JSON.parse(variantsEl.textContent);
        var idInput = pdp.querySelector("[name=id]");
        var priceEl = pdp.querySelector("[data-nd-price]");
        var selected = [];
        var groups = pdp.querySelectorAll("[data-nd-opt]");
        groups.forEach(function (g, gi) {
            var first = g.querySelector(".nd-opt__val");
            selected[gi] = first ? first.getAttribute("data-val") : null;
            g.querySelectorAll(".nd-opt__val").forEach(function (btn) {
                btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    g.querySelectorAll(".nd-opt__val").forEach(function (b) { b.classList.remove("nd-active"); });
                    btn.classList.add("nd-active");
                    selected[gi] = btn.getAttribute("data-val");
                    var lbl = g.querySelector("[data-nd-opt-current]");
                    if (lbl) lbl.textContent = selected[gi];
                    sync();
                });
            });
        });

        function sync() {
            var v = variants.find(function (x) {
                return x.options.every(function (o, i) { return o === selected[i]; });
            });
            if (v && idInput) {
                idInput.value = v.id;
                if (priceEl) {
                    var html = "";
                    if (v.compare_at_price > v.price) html += "<s>" + fmt(v.compare_at_price) + "</s>";
                    html += '<span class="' + (v.compare_at_price > v.price ? "nd-sale" : "") + '">' + fmt(v.price) + "</span>";
                    priceEl.innerHTML = html;
                }
                var btn = pdp.querySelector("[data-nd-atc-btn]");
                if (btn) {
                    btn.disabled = !v.available;
                    btn.textContent = v.available ? btn.getAttribute("data-label") : "Sold out";
                }
            }
        }
        sync();

        var qtyEl = pdp.querySelector("[name=quantity]");
        pdp.querySelectorAll("[data-nd-step]").forEach(function (b) {
            b.addEventListener("click", function () {
                if (!qtyEl) return;
                var q = Math.max(1, parseInt(qtyEl.value || "1", 10) + parseInt(b.getAttribute("data-nd-step"), 10));
                qtyEl.value = q;
                var qv = pdp.querySelector("[data-nd-qty-view]");
                if (qv) qv.textContent = q;
            });
        });
    });
})();


/* ── Shop the Look: drag hotspots + upload own photo ─────────────── */
(function () {
  document.querySelectorAll("[data-nd-look]").forEach(function (section) {
    /* DRAG: hotspot slankiojimas pele ir pirštu */
    section.querySelectorAll("[data-nd-draggable]").forEach(function (hot) {
      var room = hot.getAttribute("data-room");
      var n = hot.getAttribute("data-n");
      var storeKey = "nd-look-" + room + "-" + n;
      /* atstatyti išsaugotą poziciją */
      try {
        var saved = localStorage.getItem(storeKey);
        if (saved) {
          var pos = JSON.parse(saved);
          hot.style.left = pos.x + "%";
          hot.style.top = pos.y + "%";
        }
      } catch (e) {}
      var dragging = false;
      var movedFar = false;
      var startX = 0, startY = 0;
      function move(clientX, clientY) {
        var scene = hot.closest(".nd-look__scene");
        var rect = scene.getBoundingClientRect();
        var x = Math.min(97, Math.max(3, ((clientX - rect.left) / rect.width) * 100));
        var y = Math.min(97, Math.max(3, ((clientY - rect.top) / rect.height) * 100));
        hot.style.left = x + "%";
        hot.style.top = y + "%";
        try { localStorage.setItem(storeKey, JSON.stringify({ x: Math.round(x), y: Math.round(y) })); } catch (e) {}
        if (Math.abs(clientX - startX) > 6 || Math.abs(clientY - startY) > 6) movedFar = true;
      }
      hot.addEventListener("mousedown", function (e) {
        dragging = true;
        movedFar = false;
        startX = e.clientX; startY = e.clientY;
        e.preventDefault();
        e.stopPropagation();
        function onMove(ev) { if (dragging) move(ev.clientX, ev.clientY); }
        function onUp(ev) {
          dragging = false;
          document.removeEventListener("mousemove", onMove);
          document.removeEventListener("mouseup", onUp);
          if (movedFar) {
            ev.preventDefault(); ev.stopPropagation();
            hot.addEventListener("click", function stop(ev2) {
              ev2.preventDefault(); ev2.stopPropagation();
              hot.removeEventListener("click", stop);
            }, true);
          }
        }
        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onUp);
      });
      hot.addEventListener("touchstart", function (e) {
        dragging = true;
        var t = e.touches[0];
        function onMove(ev) {
          if (!dragging) return;
          move(ev.touches[0].clientX, ev.touches[0].clientY);
        }
        function onUp() {
          dragging = false;
          document.removeEventListener("touchmove", onMove);
          document.removeEventListener("touchend", onUp);
        }
        document.addEventListener("touchmove", onMove, { passive: false });
        document.addEventListener("touchend", onUp);
      }, { passive: true });
    });

    /* UPLOAD: "Use your own photo" — client-side FileReader */
    section.querySelectorAll("[data-nd-upload]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-nd-upload");
        var fileInput = section.querySelector('[data-nd-file="' + id + '"]');
        if (fileInput) fileInput.click();
      });
    });
    section.querySelectorAll(".nd-look__file").forEach(function (fileInput) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        if (!file) return;
        var id = fileInput.getAttribute("data-nd-file");
        var scene = section.querySelector('[data-nd-room-panel="' + id + '"]');
        if (!scene) return;
        var img = scene.querySelector("img");
        var reader = new FileReader();
        reader.onload = function (ev) {
          if (img) {
            img.src = ev.target.result;
            img.removeAttribute("srcset");
          }
        };
        reader.readAsDataURL(file);
      });
    });
  });
})();
